/* eslint-disable @typescript-eslint/no-explicit-any */
import NumberFormat, {
  InputAttributes,
  NumberFormatValues,
} from "react-number-format";

type NumberFormatState = {
  value?: string;
  numAsString?: string;
  mounted: boolean;
};

const getNumAsString = ({ numAsString }: NumberFormatState): string => {
  if (numAsString === undefined) return "";
  if (Number.isNaN(parseFloat(numAsString))) return "";
  return numAsString;
};

// https://github.com/s-yadav/react-number-format/issues/531
export function getValueObjectFromNumberFormatComponentInstance(
  instance: NumberFormat<InputAttributes>
): NumberFormatValues {
  const numAsString = getNumAsString(instance.state as NumberFormatState);
  const formattedValue: string = (instance as any).formatNumString(numAsString);
  return (instance as any).getValueObject(formattedValue, numAsString);
}

export const getFormattedFloatVal = (
  numToTest: number | null,
  maxDecimalCount: number
): number | null => {
  if (numToTest === null) return numToTest;

  const [number, decimal] = String(numToTest).split(/\.|,/);

  if (!decimal) return numToTest;

  const formattedDecimal = decimal.slice(0, maxDecimalCount);

  return Number(`${number}.${formattedDecimal}`);
};
